<template>
  <div class="content-veracity-filter-container" :style="containerStyle">
    <v-select
      class="content-veracity-filter-control"
      :items="veracities"
      item-text="name"
      v-model="selectedVeracities"
      :placeholder="controlLabel"
      outlined
      multiple
      return-object
    >
      <template v-slot:selection="{ item, index }">
        <span v-if="index === 0">
          {{ selectedVeracities.length }} Veracities
        </span>
      </template>
    </v-select>
  </div>
</template>

<script>
import { VERACITIES } from "@/common/constants/veracity";
import lodashDebounce from "lodash/debounce";
import { MODULE_PREFIX_HOME, MODULE_PREFIX_USER } from "@/store";
import { SAVE_PREFERENCES } from "@/store/actions.type";
import lodashGet from "lodash/get";
import lodashCloneDeep from "lodash/cloneDeep";
import lodashOrderBy from "lodash/orderBy";
import { mapGetters } from "vuex";

export default {
  name: "ContentVeracityFilter",
  props: {
    value: {
      type: Array,
    },
    isIndependent: {
      type: Boolean,
    },
    defaultLabel: {
      type: String,
      default: "Veracity",
    },
    width: {
      type: String,
      default: "120",
    },
  },
  created() {
    this.getPrefs();
  },
  data() {
    return {
      selectedVeracities: [],
      veracities: this.sortedVeracities(),
    };
  },
  computed: {
    ...mapGetters({
      selectorPanel: MODULE_PREFIX_HOME + "selectorPanel",
      preferences: MODULE_PREFIX_USER + "preferences",
    }),
    controlLabel() {
      return this.selectedVeracities && this.selectedVeracities.length === 0
        ? this.defaultLabel
        : "";
    },
    containerStyle() {
      return {
        width: `${this.width}px`,
      };
    },
  },
  methods: {
    sortedVeracities() {
      let veracities = [];
      VERACITIES.map(function (item) {
        if (item.display) {
          veracities.push(item);
        }
      });
      return lodashOrderBy(veracities, "name", "asc");
    },
    async savePrefs() {
      if (this.preferences.alerts && this.preferences.alerts.content) {
        this.preferences.alerts.content.veracityFilter = this.selectedVeracities;
        await this.$store.dispatch(
          MODULE_PREFIX_USER + SAVE_PREFERENCES,
          this.preferences
        );
      }
    },
    getPrefs() {
      if (!this.isIndependent) {
        const veracityFilter = lodashGet(
          this.preferences,
          "alerts.content.veracityFilter"
        );

        if (veracityFilter) {
          this.selectedVeracities = lodashCloneDeep(
            this.preferences.alerts.content.veracityFilter
          );
        } else {
          this.selectedVeracities = [];
        }
      }

      if (lodashGet(this.selectorPanel, "selectedData")) {
        this.selectedVeracities = [];
      }
    },
  },
  watch: {
    selectedVeracities: lodashDebounce(function () {
      if (this.isIndependent) {
        this.$emit("callback", {
          field: "veracityFilters",
          data: this.selectedVeracities,
        });
      } else {
        this.savePrefs();
      }
    }, 500),
  },
};
</script>

<style scoped>
.content-veracity-filter-container {
  padding: 5px 5px 0 0;
}
.content-veracity-filter-control >>> .v-input__control {
  width: 125px;
  height: 35px !important;
}
.content-veracity-filter-control >>> .v-input__slot {
  border-radius: 10px;
  min-height: auto;
}
.content-veracity-filter-control >>> .v-label {
  top: auto;
  color: #646464;
}
.content-veracity-filter-control >>> .v-input__append-inner {
  display: none;
}
.content-veracity-filter-control >>> .v-select__selections {
  padding: 0 !important;
}
.content-veracity-filter-control >>> .v-select__selection {
  padding: 0 !important;
  color: #646464;
}
.content-veracity-filter-control >>> .v-list-item__action {
  margin-right: 10px !important;
}
</style>
